import { render } from "./LibraryItems.vue?vue&type=template&id=427498ac&lang=pug"
import script from "./LibraryItems.vue?vue&type=script&lang=js"
export * from "./LibraryItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__